import { ColumnFilter } from "./column-filter";
import { FilterOperator } from "./filter-operator";

export class ColumnFilterBuilder {

  private _filter: Partial<ColumnFilter> = {};

  public setColumn(column: string): this {

    if(column.length === 0) {
      throw new Error('Column name cannot be empty');
    }

    const old = this._filter;
    this._filter = {...old, column};
    return this;
  }

  public setOperator(operator: FilterOperator): this {
    const old = this._filter;
    this._filter = {...old, operator}
    return this;
  }

  public setTerm(term: string): this {

    if(term.length === 0) {
      throw new Error('Search term cannot be empty');
    }

    const old = this._filter;
    this._filter = {...old, term};
    return this;
  }

  public setNot(not: boolean): this {
    const old = this._filter;
    this._filter = {...old, not }
    return this;
  }

  public setColumnEqualsTerm(column: string, term: string): this {
    this.setColumn(column);
    this.setTerm(term);
    this.setOperator(FilterOperator.Equals);
    this.setNot(false);

    return this;
  }

  public setColumnContainsTerm(column: string, term: string): this {
    this.setColumn(column);
    this.setTerm(term);
    this.setOperator(FilterOperator.Contains);
    this.setNot(false);

    return this;
  }

  private _isColumnFilter(value: Partial<ColumnFilter>): value is ColumnFilter {

    const { column, term, operator, not } = value;

    return column !== undefined
      && term !== undefined
      && operator !== undefined
      && not !== undefined;
  }

  public build(): ColumnFilter {
    const filter = this._filter;
    if(!this._isColumnFilter(filter)) {
      throw new Error('Filter is incomplete');
    }

    return filter;
  }

  public buildAndWrapInArray(): readonly ColumnFilter[] {
    return [this.build()];
  }
}
